import { useLayoutEffect, useRef } from "react"
import { ChainPointStyled } from "./styled"
import BlockState from "pages/scheme-editor/store/block"
import { useSchemeEditorStore } from "pages/scheme-editor/store"

type Props = {
  state: BlockState
}

const ChainCollector = ({ state }: Props) => {

  const store = useSchemeEditorStore()
  const ref = useRef<HTMLButtonElement>(null)
  useLayoutEffect(() => {
    state.setChainPos(ref.current!)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ChainPointStyled 
      sx={{ left: -5.5, right: "auto" }} 
      ref={ref}
      onMouseDown={(e) => store.onChainPointClick(e, state.id)}
    />
  )
}

export default ChainCollector